import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { TYPES, SIZES } from '../../constants';
import VisaIcon from '../../icons/visa-icon';
import BoletoIcon from '../../icons/boleto-icon';
import MasterCardIcon from '../../icons/master-card-icon';
import AmericanExpressIcon from '../../icons/american-express-icon';
import PayPalIcon from '../../icons/pay-pal-icon';
import DiscoverIcon from '../../icons/dicover-icon';
import StripeIcon from '../../icons/stripe-icon';
import JcbIcon from '../../icons/jcb-icon';
import UnionPayIcon from '../../icons/union-pay-icon';
import CardIcon from '../../icons/card-icon';
import DinersIcon from '../../icons/diners-icon';

function getPaymentMethodIcon(type) {
  switch (type) {
    case TYPES.boleto:
      return <BoletoIcon />;
    case TYPES.mastercard:
      return <MasterCardIcon />;
    case TYPES.visa:
      return <VisaIcon />;
    case TYPES.discover:
      return <DiscoverIcon />;
    case TYPES.paypal:
      return <PayPalIcon />;
    case TYPES.americanExpress:
      return <AmericanExpressIcon />;
    case TYPES.stripe:
      return <StripeIcon />;
    case TYPES.jcb:
      return <JcbIcon />;
    case TYPES.unionpay:
      return <UnionPayIcon />;
    case TYPES.diners:
      return <DinersIcon />;
    default:
      return <CardIcon />;
  }
}

const PaymentMethod = ({ type, size = SIZES.large }) => {
  const classes = classnames('ws-ui-payment-method', `ws-ui-payment-method--${size}`);

  return <div className={classes}>{getPaymentMethodIcon(type)}</div>;
};

PaymentMethod.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.oneOf(Object.values(SIZES)),
};

export default PaymentMethod;
